<template>
  <div>
    <Opciones
      v-if="this.step.tipoPantalla == 'o' || this.step.tipoPantalla == 'o2'"
      @elegido="goNext"
    />
    <Numero v-if="this.step.tipoPantalla == 'e'" @elegido="goNext" />
    <Fecha
      v-if="this.step.tipoPantalla == 'f'"
      @elegido="goNext"
      :fechaDefault="this.step.fechaDefault"
    />
    <Combo v-if="this.step.tipoPantalla == 'b'" @elegido="goNext" />
    <Aviso v-if="this.step.tipoPantalla == 'a'" @elegido="goNext" />
    <Checks v-if="this.step.tipoPantalla == 'c'" @elegido="goNext" />
    <Precios v-if="this.step.tipoPantalla == 'p'" @elegido="goNext" />
    <DatosIdentificacion
      v-if="this.step.tipoPantalla == 'i'"
      @elegido="goNext"
    />
    <Resumen v-if="this.step.tipoPantalla == 'r'" @elegido="goNext" />
    <NumPresupuesto v-if="this.step.tipoPantalla == 'n'" @elegido="goNext" />
  </div>
</template>

<script>
import actions from "@/util/actions.js";

export default {
  store: ["step", "select"],

  data() {
    return {
      np: false
    };
  },

  mounted: async function() {
    this.np = this.$route.params.np;
    if (!this.np) {
      this.np = "tipoAutomovil";
    }
    await actions.getInfoPaso(this.np, []);
  },

  methods: {
    goNext: async function(respuesta) {
      console.log("respuesta seleccionada:" + respuesta);

      if (this.np == "tipoAutomovil") {
        this.step.idTipoAutomovil = respuesta;
      }

      if (this.np == "marcaVehiculoPresel" || this.np == "marcaVehiculo") {
        this.step.idMarca = respuesta;
      }

      if (this.np == "modeloVehiculo") {
        this.step.idModelo = respuesta;
      }

      if (this.np == "versionVehiculo") {
        this.step.idVersion = respuesta;
      }

      if (this.np == "datosIdentificacion") {
        this.step.datosIdentificacion = respuesta;
        respuesta = "";
      }

      if (this.np == "tipoAutomovil") {
        this.step.conductorHabitual = true;
      }

      let resp = await actions.getNextPaso(this.np, respuesta);

      if (resp.codigo == 0) {
        this.$router.push({
          name: "pres",
          params: {
            np: resp.data.nombrePaso,
            presCodif: this.step.idPresupuesto
          }
        });
      } else if (resp.codigo == 1008 || resp.codigo == 9999) {
        console.log("resp.mensaje " + resp.mensaje);
        this.$router.push({
          name: "ShowErrorPresupuesto",
          params: {
            errorMessage: resp.mensaje
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
